/* eslint-disable import/no-cycle */
import { useMemo, useRef } from 'react';
import isUndefined from 'lodash/isUndefined';
import { isSectionSchema, isFieldSchema } from '../utils';
import { FormItemT } from '../types';
import { useStoreState } from '../../../../models/hooks';

export function getParentId(items: FormItemT[], targetId: string, currentParentId: string | null): string | null | undefined {
  if (!items || !Array.isArray(items)) {
    return undefined;
  }
  /* eslint-disable-next-line */
  for (const item of items) {
    if (!item || isUndefined(item.id)) /* eslint-disable-line no-continue */ continue;

    if (item.id === targetId) {
      return currentParentId;
    }

    if (isSectionSchema(item) && Array.isArray(item.fields)) {
      const foundParentId = getParentId(item.fields, targetId, item.id);
      if (foundParentId !== undefined) {
        return foundParentId;
      }
    } else if (isFieldSchema(item) && item.inputType === 'yesNo' && Array.isArray(item.followUpQuestionList)) {
      if (item.followUpQuestionList) {
        const foundParentId = getParentId(item.followUpQuestionList, targetId, item.id);
        if (foundParentId !== undefined) {
          return foundParentId;
        }
      }
    }
  }

  return undefined;
}

export function useGetParentId(targetItemId?: string | null): string | null {
  const formSchema = useStoreState((state) => state.formBuilder.formSchema);

  const previousTargetItemIdRef = useRef<string | null | undefined>(undefined);
  const previousParentIdRef = useRef<string | null>(null);

  const currentParentId = useMemo(() => {
    if (!targetItemId || !formSchema || !Array.isArray(formSchema) || formSchema.length === 0) {
      return null;
    }
    const result = getParentId(formSchema, targetItemId, null);
    return result === undefined ? null : result;
  }, [formSchema, targetItemId]);

  if (previousTargetItemIdRef.current === targetItemId && previousParentIdRef.current === currentParentId) {
    return previousParentIdRef.current;
  }
  previousTargetItemIdRef.current = targetItemId;
  previousParentIdRef.current = currentParentId;
  return currentParentId;
}
